import { EscoposPadraoScreen } from "@/screens/financeiro/configuracoes/escopos-padrao";

export function FinanceiroEscoposPadraoPage() {
  return <EscoposPadraoScreen />;
}
